// extracted by mini-css-extract-plugin
export default {"root":"GetStarted_root__JWc+n","title":"GetStarted_title__1FRPW","images":"GetStarted_images__m52hz","calendar":"GetStarted_calendar__TDXkn"};